import { CompanyFormData } from "Components/Companies/CompanyEdit/CompanyEditForm";
import * as React from "react";
import { UseFormMethods } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";
import { setDisableRedirect } from "State/App/AppReducer";
import { useDispatch } from "react-redux";
import { nameof } from "Utils/ObjectUtils";
import styled from "styled-components";
import { Checkbox } from "Components/Shared/Inputs/Checkbox";

type Props = {
  form: UseFormMethods<CompanyFormData>;
};

const StyledCheckboxes = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 215px) minmax(auto, 215px) auto 1fr;
  gap: ${props => props.theme.spacing(1, 3)};
  margin-bottom: ${props => props.theme.spacing(3)}px;
`;

export const CompanyEditCheckboxes: React.FunctionComponent<Props> = props => {
  const { register, watch, setValue } = props.form;
  const { t } = useResource();
  const dispatch = useDispatch();
  const { isCustomer, isSupplier, isMarketplaceEnabled } = watch();

  React.useEffect(() => {
    register({ name: nameof<CompanyFormData>("isCustomer") });
    register({ name: nameof<CompanyFormData>("isMarketplaceEnabled") });
    register({
      name: nameof<CompanyFormData>("isSupplier"),
    });
  }, [register]);

  const handleClick = (propertyName: keyof CompanyFormData) => {
    let value = props.form.getValues()[propertyName];

    setValue(propertyName, !value);
    dispatch(setDisableRedirect(true));
  };

  return (
    <>
      <div className={"form-title"}>{t(Resources.CompanyEdit.Role.Label)}</div>
      <StyledCheckboxes>
        <Checkbox
          label={t(Resources.CompanyEdit.IsCustomer.Label)}
          id={"isCustomer"}
          checked={isCustomer}
          onClick={() => handleClick("isCustomer")}
        ></Checkbox>

        <Checkbox
          label={t(Resources.CompanyEdit.IsSupplier.Label)}
          id={"isSupplier"}
          checked={isSupplier}
          onClick={() => handleClick("isSupplier")}
        ></Checkbox>
      </StyledCheckboxes>
      <StyledCheckboxes>
        <Checkbox
          label={"Marketplace"}
          id={"isMarketplaceEnabled"}
          checked={isMarketplaceEnabled}
          onClick={() => handleClick("isMarketplaceEnabled")}
        ></Checkbox>
      </StyledCheckboxes>
    </>
  );
};
